module.exports = __webpack_public_path__ + "img/andrew.cc5811fe.png";